export {
  Slide,
  SlidesCarousel,
  initChiefSlider,
} from './impl'


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/shared/core/index.jsx